<template>
  <div class="home sb-nav-fixed">
    <top-header />
    <div id="layoutSidenav">
      <main-sidebar />
      <div id="layoutSidenav_content">
        <main id="main_content">
          <cms-status-banner />
          <router-view></router-view>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from '../components/layouts/TopHeader'
import MainSidebar from '../components/layouts/MainSidebar'
import CmsStatusBanner from '../components/layouts/CmsStatusBanner'
import {mapGetters} from "vuex";

export default {
  name: 'Base',
  components: {
    'top-header': TopHeader,
    'main-sidebar': MainSidebar,
    'cms-status-banner': CmsStatusBanner
  },
  computed:{
    ...mapGetters(["CIactivetrees"]),
  },
  watch: {
    '$route': function(to, from) {
      this.$store.commit('SET_ACTIVE_TREES', [])
    }
  },
}
</script>

<style scoped>

</style>
